import cloneDeep from 'lodash.clonedeep';
import React, { ReactNode } from 'react';
import deepEqual from 'react-fast-compare';
import { $ReadOnly } from 'utility-types';

import { arrToObject, getIn, partial, updateIn, zip } from 'utils/functional';
import scrollIntoView from 'utils/scrollIntoView';

import { FormContextProvider, SubmitInterceptor } from './FormContext';

const scrollToError = (isModal?: boolean) => {
  const firstError = document.querySelector('.error');

  if (firstError) {
    scrollIntoView(firstError, {
      padding: 32,
      container: isModal ? 'idealist-modal-container' : undefined,
    });
  }
};

// support nested form attributes by parsing dot notation in field names
// e.g. "profile.description"
const getValue = (values, name: string) => getIn(values, name.split('.'));

const updateField = (prev, name: string, updater) =>
  updateIn(prev, name.split('.'), updater);

export type FormRenderProps = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: Record<string, any>;
  getValue: (arg0: string) => unknown;
  hasErrors: boolean;
  updateValue: (
    name: string,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback?: (...args: Array<any>) => any
  ) => void;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateValues: (arg0: Record<string, any>) => void;
  updateValueWith: (
    name: string,
    f: (arg0: unknown) => unknown,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback?: (...args: Array<any>) => any
  ) => void;
  setErrors: (arg0: APIErrors) => void;
  edited: boolean;
  submitting: boolean;
  submitDisabled: boolean;
  updateSubmitDisabled: (arg0: boolean) => void;
  errors?: APIErrors;
  submitForm: () => void;
  handleError: (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: Record<string, any>,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updatedFormData: Record<string, any> | null | undefined
  ) => void;
  clearErrors: (arg0: Array<string> | null | undefined) => void;
};
type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialValues: $ReadOnly<Record<string, any>>;
  id?: string;
  errors?: APIErrors;
  noScrollToError?: boolean;
  hasStickyHeader?: boolean;
  headerOffset?: number;
  mapError: (arg0: {
    name: string;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: Record<string, any> | null | undefined;
    type: string | null | undefined;
    description: string;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: Record<string, any>;
  }) => ReactNode;
  onSubmit: (arg0: {
    clearErrors: (arg0: Array<string> | null | undefined) => void;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    values: Record<string, any>;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateValues: (update: Record<string, any>) => void;
    updateValueWith: (
      name: string,
      f: (arg0: unknown) => unknown,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      callback?: (...args: Array<any>) => any
    ) => void;
    updateSubmitting: (arg0: boolean) => void;
    handleError: (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      error: Record<string, any>,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      updatedFormData: Record<string, any> | null | undefined
    ) => void;
    setErrors: (arg0: APIErrors) => void;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }) => Promise<Record<string, any>> | Promise<void> | null | undefined;
  render: (arg0: FormRenderProps) => ReactNode;
  'data-qa-id'?: string;
  'data-qa'?: Record<string, string>;
  className?: string;
  component?:
    | string
    | React.ComponentType<{
        'data-qa-id'?: string;
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onSubmit: (...args: Array<any>) => any;
        className?: string;
        id?: string;
      }>;
  formRef?: {
    current: null | React.ElementRef<React.ElementType>;
  };
  isModal?: boolean;
};
type State = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: Record<string, any>;
  errors: APIErrors;
  submitting: boolean;
  submitDisabled: boolean;
  fetchingAddress: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  prevPropsInitialValues: Record<string, any>;
  edited: boolean;
};
export default class FormContainer extends React.Component<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    mapError: ({ description }: { description: string }) => description,
    // eslint-disable-next-line react/default-props-match-prop-types
    initialValues: {},
  };

  private submitInterceptors: SubmitInterceptor[] = [];

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    // deep clone to avoid mutating state
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    values: cloneDeep(this.props.initialValues),
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    errors: this.props.errors || {},
    submitting: false,
    submitDisabled: false,
    fetchingAddress: false,
    // eslint-disable-next-line react/no-unused-state, react/destructuring-assignment
    prevPropsInitialValues: this.props.initialValues,
    edited: false,
  };

  onFetchingAddressComplete: (() => void) | null | undefined;

  // TODO(Karan): do we need this? remove it otherwise
  // See https://www.pivotaltracker.com/story/show/169410492
  // for bug caused by this. This code assumes that all fields in a form
  // will be keys in `this.props.initialValues`
  static getDerivedStateFromProps(props: Props, state: State) {
    const initialValuesChanged = !deepEqual(
      props.initialValues,
      state.prevPropsInitialValues
    );
    const currentFields = Object.keys(state.values);
    const newFields = Object.keys(props.initialValues).filter(
      (f) => !currentFields.includes(f)
    );
    const hasNewFields = newFields.length > 0;
    const newValues = newFields.reduce((memo, formField) => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-param-reassign
      memo[formField] = props.initialValues[formField];
      return memo;
    }, {});

    if (!initialValuesChanged) {
      if (!hasNewFields || state.submitting) {
        return null;
      }

      return {
        values: { ...state.values, ...newValues },
      };
    }

    // if initialValues is updated and the user hasn't changed the updated
    // form fields, update the field's value
    const updatedFormData = Object.keys(props.initialValues).reduce(
      (memo, formField) => {
        const prevDefaultValue = state.prevPropsInitialValues[formField];
        const newDefaultValue = props.initialValues[formField];
        const currentValue = state.values[formField];

        if (
          !deepEqual(prevDefaultValue, newDefaultValue) &&
          deepEqual(currentValue, prevDefaultValue)
        ) {
          // deep clone to avoid mutating state
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line no-param-reassign
          memo[formField] = cloneDeep(newDefaultValue);
        } else {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line no-param-reassign
          memo[formField] = currentValue;
        }

        return memo;
      },
      newValues
    );
    return {
      values: updatedFormData,
      prevPropsInitialValues: props.initialValues,
    };
  }

  componentDidUpdate() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.state.fetchingAddress && this.onFetchingAddressComplete) {
      this.onFetchingAddressComplete();
      this.onFetchingAddressComplete = null;
    }
  }

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/sort-comp
  updateValue = (
    name: string,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    newValue: any,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback?: (...args: Array<any>) => any
  ) => this.updateValueWith(name, () => newValue, callback);

  // updateValueWith
  // single field with updater function (e.g., incrementing):
  // updateValueWith('field1', oldField1 => oldField1 + 1)
  // multiple fields at once (e.g., incrementing):;
  // updateValueWith(['field1', 'field2'], ({field1, field2}) => {field1: field1 + 1, field2: field2 + 1})
  updateValueWith = (
    name: string | ReadonlyArray<string>,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update: (arg0: string | Record<string, any>) => Record<string, any>,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback?: (...args: Array<any>) => any
  ) => {
    this.setState((prevState) => {
      let updatedValues;

      if (typeof name === 'string') {
        updatedValues = updateField(prevState.values, name, update);
      } else {
        const updaterArg = arrToObject(
          zip(name, name.map(partial(getValue, prevState.values)))
        );
        const newValues = update(updaterArg);
        updatedValues = Object.entries(newValues).reduce(
          // $FlowFixMe: annoying tuple / array incompatibility
          (acc, [field, val]) => updateField(acc, field, () => val),
          prevState.values
        );
      }

      return {
        values: updatedValues,
        edited: prevState.edited || !deepEqual(prevState.values, updatedValues),
      };
    }, callback);
  };

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateValues = (update: Record<string, any>) => {
    this.updateValueWith(Object.keys(update), () => update);
  };

  updateSubmitting = (submitting: boolean) => {
    this.setState({
      submitting,
    });
  };

  updateSubmitDisabled = (submitDisabled: boolean) => {
    this.setState({
      submitDisabled,
    });
  };

  clearErrors = (names: Array<string> | null | undefined) => {
    this.setState((state) => {
      if (!(names && names.length)) {
        return {
          errors: {},
        };
      }

      const newErrors = state.errors;
      names.forEach((name) => {
        delete newErrors[name];
      });
      return {
        errors: newErrors,
      };
    });
  };

  handleError = (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: Record<string, any>,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updatedFormData: Record<string, any> | null | undefined = null
  ) => {
    const { mapError } = this.props;
    const errorArray = error.responseJson && error.responseJson.errors;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    if (!errorArray) throw error;
    const errors = errorArray.reduce(
      (acc, { name, type, description, data }) => {
        // eslint-disable-next-line no-param-reassign
        acc[name] = mapError({
          name,
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          value: this.state.values[name],
          type,
          description,
          data: data || {},
        });
        return acc;
      },
      {}
    );
    const updatedState = {};
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'submitting' does not exist on type '{}'.
    updatedState.submitting = false;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'errors' does not exist on type '{}'.
    updatedState.errors = errors;

    if (updatedFormData) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'values' does not exist on type '{}'.
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      updatedState.values = { ...this.state.values, ...updatedFormData };
    }

    this.setState(updatedState);

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.props.noScrollToError) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      scrollToError(this.props.isModal);
    }
  };

  setErrors = (errors: APIErrors) => {
    this.setState({
      submitting: false,
      errors,
    });

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.props.noScrollToError) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      scrollToError(this.props.isModal);
    }
  };

  get hasErrors() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    return Object.keys(this.state.errors).length > 0;
  }

  setFetchingAddress = (fetchingAddress: boolean) => {
    this.setState({
      fetchingAddress,
    });
  };

  submitForm = async () => {
    this.submitInterceptors.forEach((interceptor) => interceptor());

    await this.setState((prevState) => ({
      submitting: true,
      // reset the errors on form submission
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      errors: this.props.errors ? prevState.errors : {},
    }));

    const performSubmit = () => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      if (this.props.onSubmit) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.onSubmit({
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          values: this.state.values,
          updateValues: this.updateValues,
          updateValueWith: this.updateValueWith,
          updateSubmitting: this.updateSubmitting,
          clearErrors: this.clearErrors,
          handleError: this.handleError,
          setErrors: this.setErrors,
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ values: any; updateValues: (up... Remove this comment to see the full error message
          setFetchingAddress: this.setFetchingAddress,
        });
      }
    };

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.fetchingAddress) {
      this.onFetchingAddressComplete = performSubmit;
    } else {
      performSubmit();
    }
  };

  /**
   * @returns a function to remove the interceptor
   */
  addSubmitInterceptor = (interceptor: SubmitInterceptor) => {
    this.submitInterceptors.push(interceptor);

    return () => {
      const index = this.submitInterceptors.indexOf(interceptor);
      this.submitInterceptors.splice(index, 1);
    };
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    const FormComponent = this.props.component || 'form';
    return (
      <FormContextProvider
        value={{
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          values: this.state.values,
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          getValue: partial(getValue, this.state.values),
          updateValue: this.updateValue,
          updateValues: this.updateValues,
          updateValueWith: this.updateValueWith,
          setFetchingAddress: this.setFetchingAddress,
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          errors: this.state.errors,
          setErrors: this.setErrors,
          clearErrors: this.clearErrors,
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          submitting: this.state.submitting,
          updateSubmitting: this.updateSubmitting,
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          submitDisabled: this.state.submitDisabled,
          updateSubmitDisabled: this.updateSubmitDisabled,
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          fieldQaIdPrefix: this.props['data-qa-id'],
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          edited: this.state.edited,
          handleError: this.handleError,
          addSubmitInterceptor: this.addSubmitInterceptor,
        }}
      >
        <FormComponent
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          ref={this.props.formRef}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          data-qa-id={this.props['data-qa-id']}
          onSubmit={(e) => {
            e.preventDefault();
            this.submitForm();
          }}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          className={this.props.className}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          id={this.props.id}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...arrToObject(
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            Object.entries(this.props['data-qa'] || {}).map(([key, value]) => [
              `data-qa-${key}`,
              value,
            ])
          )}
        >
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/destructuring-assignment */}
          {this.props.render({
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            values: this.state.values,
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            getValue: partial(getValue, this.state.values),
            updateValue: this.updateValue,
            updateValueWith: this.updateValueWith,
            updateValues: this.updateValues,
            hasErrors: this.hasErrors,
            setErrors: this.setErrors,
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            submitting: this.state.submitting,
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            submitDisabled: this.state.submitDisabled,
            updateSubmitDisabled: this.updateSubmitDisabled,
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            errors: this.state.errors,
            submitForm: this.submitForm,
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            edited: this.state.edited,
            handleError: this.handleError,
            clearErrors: this.clearErrors,
          })}
        </FormComponent>
      </FormContextProvider>
    );
  }
}
